import React, { PureComponent } from 'react';
import moment from 'moment';

export default class SectionTypeDate extends PureComponent {

  render() {
    const { start, end } = this.props;
    const mStart_date = moment(new Date(start)).format('D');
    const mEnd_date = moment(new Date(end)).format('DD MMMM YYYY');
    return (
      <p>
        {mStart_date} a {mEnd_date}
      </p>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/type-of-sections/date/index.js